import { useSyncExternalStore } from 'react';

// Whether the Cloudflare Access sign-in has run out. Access sessions last 24h;
// after that every API call is redirected to the sign-in page, which fetch can't
// follow cross-origin, so the browser reported a bare "TypeError: Failed to
// fetch" and staff lost a half-typed listing to a refresh (NCC, 2026-10-28).
// request() in api.ts flips this on that redirect and off on the next success;
// SessionBanner reads it.
let expired = false;
const listeners = new Set<() => void>();

export function setSessionExpired(value: boolean) {
  if (expired === value) return;
  expired = value;
  listeners.forEach((l) => l());
}

export function useSessionExpired(): boolean {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => expired,
  );
}
